<div class="right-side p-5">
  <h2>On Spot Registration Details</h2>
  <div class="section">

    <form [formGroup]="onspotuserform">

      <div class="row">
        <div class="text-end">
          <button (click)="exportToExcel()" type="button" class="btn btn-sm btn-success me-2">Export to Excel</button>
        </div>
        <div class="col-lg-7 col-sm-12">
          <div class="search-container">
            <mat-form-field class="search-input w-75" appearance="outline">
              <mat-label>Search</mat-label>
              <input matInput formControlName="searchControl" />
            </mat-form-field>
            <button class="btn btn-outline-secondary p-2 mx-1 search-button" type="submit" (click)="onSearchClick(onspotuserform.get('searchControl')?.value ?? '')" id="btnSearch">
              <i class="bi bi-search fs-4"></i>
            </button>
            <button class="btn btn-outline-secondary p-2" type="reset" (click)="resetPage()" id="btnReset">
              <i class="bi bi-arrow-clockwise fs-4"></i>
            </button>
          </div>
          <div *ngIf="onspotuserform.get('searchControl')?.invalid && (onspotuserform.get('searchControl')?.touched || onspotuserform.get('searchControl')?.dirty)">
            <small *ngIf="onspotuserform.get('searchControl')?.errors?.['pattern']" class="text-danger">
              Invalid search term.
            </small>
          </div>
        </div>


        <div class="report-container">


          <!--<div>
          <div class="col-lg-3 col-sm-6 text-end">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>Search</mat-label>
              <input matInput (input)="onSearchChange($event)" />
            </mat-form-field>
          </div>-->
          <!--<div class="table-responsive">
            <table class="table table-striped table-bordered table-hover" style="font-size:9.5pt">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Enterprise Name</th>
                  <th>Participant Name</th>
                  <th>Email</th>
                  <th>Designation</th>
                  <th>Mobile</th>
                  <th>GST Number</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of reportData; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.enterpriseName }}</td>
                  <td>{{ item.participantName }}</td>
                  <td>{{ item.email }}</td>
                  <td>{{ item.designation }}</td>
                  <td>{{ item.mobileNumber}}</td>
                  <td>{{item.gstNumber}}</td>

                </tr>
              </tbody>
            </table>
          </div>

          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [disabled]="disabled"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>-->

          <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" class="table table-striped table-bordered table-hover" matTableResponsive matSortActive="EventDate" matSort matSortDirection="desc" matSortDisableClear>
              <ng-container matColumnDef="Sr.No">
                <th mat-header-cell *matHeaderCellDef>Sr. No.</th>
                <td mat-cell *matCellDef="let el"> {{el.rowNum}} </td>
              </ng-container>

              <!--<ng-container matColumnDef="udyamNumber">
                <th mat-header-cell *matHeaderCellDef>Udyam Number</th>
                <td mat-cell *matCellDef="let el"> {{el.udyamNumber}} </td>
              </ng-container>-->
              <!--<ng-container matColumnDef="udyamNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Number</th>
                <td mat-cell *matCellDef="let el"> {{el.udyamNumber=='True' ? 'udyamNumber' : '-'}} </td>
              </ng-container>-->
              <ng-container matColumnDef="udyamNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Udyam Number</th>
                <td mat-cell *matCellDef="let el"> {{ el.udyamNumber ? el.udyamNumber : '-' }} </td>
              </ng-container>
              <ng-container matColumnDef="eventName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Name</th>
                <td mat-cell *matCellDef="let el"> {{el.eventName}} </td>
              </ng-container>

              <ng-container matColumnDef="enterpriseName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Enterprise Name</th>
                <td mat-cell *matCellDef="let el"> {{el.enterpriseName}} </td>
              </ng-container>
              <!--<ng-container matColumnDef="participantName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Participant Name</th>
                <td mat-cell *matCellDef="let el"> {{el.participantName}} </td>
              </ng-container>-->
              <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
                <td mat-cell *matCellDef="let el"> {{el.email}} </td>
              </ng-container>
              <!--<ng-container matColumnDef="designation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Designation</th>
                <td mat-cell *matCellDef="let el"> {{el.designation}} </td>
              </ng-container>-->
              <!--<ng-container matColumnDef="mobileNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
                <td mat-cell *matCellDef="let el"> {{el.mobileNumber}} </td>
              </ng-container>-->
              <ng-container matColumnDef="mobileNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile Number</th>
                <td mat-cell *matCellDef="let el"> {{ el.udyamNumber ? el.mobileNo : el.mobileNumber }} </td>
              </ng-container>
              <ng-container matColumnDef="gstNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>GST Number</th>
                <td mat-cell *matCellDef="let el"> {{el.gstNumber}} </td>
              </ng-container>
              <ng-container matColumnDef="isRAMPRegistered">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Is RAMP Registered</th>
                <td mat-cell *matCellDef="let el"> {{el.isRAMPRegistered=='True' ? 'Yes' : 'No'}} </td>
              </ng-container>



              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              Row shown when there is no matching data.
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>

              </tr>
            </table>

          </div>
          <mat-paginator #paginator
                         class="demo-paginator"
                         (page)="onPageChange($event)"
                         [length]="length"
                         [pageSize]="pageSize"
                         [showFirstLastButtons]="showFirstLastButtons"
                         [pageSizeOptions]="pageSizeOptions"
                         [hidePageSize]="hidePageSize"
                         [pageIndex]="pageIndex"
                         aria-label="Select page">
          </mat-paginator>


        </div>

      </div>
    </form>
  </div>
</div>
